<template>
  <section id="locationView" class="statv_container statv_page_bg">
		<h1 style="position:absolute; left:-9999px; width:1px; height:1px; font-size:1px;"> 오시는 길 </h1>
    <div class="statv_page_wrapper statv_wrapper">
      <div class="location_img"></div>
      <strong class="location_txt"> 03924 서울 마포구 상암동 월드컵북로 56길 12 Trutec빌딩 5층 (상암동) </strong>
	  <div class="info_box">
			<article class="info">
				<p class="info_by"> 버스 </p> 
				<p class="info_list"> 정류장 : 월드컵파크5단지, 상암중고등학교 입구 </p>
				<p class="info_list"> 간선 : 171, 271, 670, 710, 771 </p>
				<p class="info_list"> 지선 : 5715, 7013A, 7013B, 7019, 7711, 7715, 7730 </p>
				<p class="info_list"> 광역 : 9711 </p>
			</article>
			<article class="info">
				<p class="info_by"> 지하철 </p> 
				<p class="info_list"> 디지털미디어시티 6 호선 / 공항철도 / 경의중앙선 2번 출구 </p>
			</article>
	  </div>
    </div>
  </section>
</template>
<script>
import Utils from "@/helpers/utils";
export default {
  name: "Location",
  data() {
    return {

    }
  },
  created() {
    
  },
  methods: {

  }
}
</script>
<style lang="less">
#locationView {
  height: 100%;
    .location_img {
      background-image: url("~@/assets/image/location/map_img.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 1080px;
      height: 600px;
    }
    .location_txt {
			width: 100%;
			margin: auto;
      margin-top: 34px;
      font-size: 20px;
      font-weight: 600;
      color: #8F8F8F;
      margin-bottom: 67px;
			text-align: center;
	}
	.info_box {
		display: flex;
		flex-flow: row wrap;
		justify-content: space-between;
		.info {
			display: inline-block;
			width: 500px;
			.info_by {
				font-size: 26px;
				font-weight: 900;
				color:#8F8F8F;
				padding-bottom: 12px;
				border-bottom: 1px solid #8F8F8F;
				margin-bottom: 12px;
			}
			.info_list {
				font-size: 17px;
				font-weight: 400;
				color: #8F8F8F;
				margin: 5px 0;
			}
		}
	}
}

.m #locationView{
    .location_img {
      background-image: url("~@/assets/image/location/map_img_m.png");
      width: 705px;
      height: 705px;
    }
    .location_txt {
		width: 600px;
		margin-top: 50px;
		font-size: 30px;
		text-align: center;
		transform: skew(-0.5deg);
	}
	.info_box {
		flex-flow: column wrap;
		justify-content: center;
		padding: 0 15px 160px;
		.info:first-child {
			padding-bottom: 80px;
		}
		.info {
			display: inline-block;
			width: 100%;
			transform: skew(-0.5deg);
			.info_by {
				font-size: 36px;
				padding-bottom: 15px;
				margin-bottom: 15px;
			}
			.info_list {
				font-size: 24px;
				margin: 5px 0;
			}
		}
	}
}
</style>
